<form [formGroup]="form" novalidate (keydown.enter)="$event.preventDefault()">
    <nb-card>
        <nb-card-header>{{'Meu Perfil' | translate }}</nb-card-header>

        <nb-card-body>

            <div class="form-group row">
                <label for="nome" class="col-sm-3 col-form-label">{{'Nome' | translate}}</label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" required="true" name="nome" id="nome" [placeholder]="'Nome' | translate" [(ngModel)]="usuario.Nome" formControlName="Nome">
                    </app-input>
                </div>
            </div>

            <div class="form-group row">
                <label for="email" class="col-sm-3 col-form-label">{{'Email' | translate}}</label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" required="true" name="email" id="email" [placeholder]="'Email' | translate" [(ngModel)]="usuario.Email" formControlName="Email">
                    </app-input>
                </div>
            </div>

            <div class="form-group row">
                <label for="telefone" class="col-sm-3 col-form-label">{{'Telefone' | translate }}</label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" required="true" name="telefone" id="telefone" [placeholder]="'Telefone' | translate" [(ngModel)]="usuario.Telefone" formControlName="Telefone">
                    </app-input>
                </div>
            </div>

            <div class="form-group row">
                <label for="cep" class="col-sm-3 col-form-label">{{'Cep' | translate}}: </label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" required="true" name="cep" id="cep" [placeholder]="'Cep' | translate" [(ngModel)]="usuario.Cep" formControlName="Cep" (blur)="buscaCep()">
                    </app-input>
                </div>
            </div>

            <div class="form-group row">
                <label for="telefone" class="col-sm-3 col-form-label">{{'Endereço' | translate}}</label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" required="true" name="rua" id="rua" [placeholder]="'Logradouro' | translate" [(ngModel)]="usuario.Logradouro" formControlName="Logradouro">
                    </app-input>
                </div>
            </div>



            <div class="form-group row">
                <label for="numero" class="col-sm-3 col-form-label">{{'Numero' | translate}}: </label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" required="true" name="numero" id="numero" [placeholder]="'Número' | translate" [(ngModel)]="usuario.Numero" formControlName="Numero">
                    </app-input>
                </div>
            </div>

            <div class="form-group row">
                <label for="complemento" class="col-sm-3 col-form-label">{{'Complemento' | translate}}: </label>
                <div class="col-sm-9">
                    <app-input>
                        <input type="text" class="form-control" name="complemento" id="complemento" [placeholder]="'Complemento' | translate" [(ngModel)]="usuario.Complemento" formControlName="Complemento">
                    </app-input>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">{{'Cidade' | translate}}: </label>
                <div class="col-sm-9">
                    <typeahead name="cidadeAutoComplete" [lista]="data" [searchText]="usuario.Cidade.Nome" (searchFunction)="onChangeCidade($event)" (selectItem)="selecionaCidade($event)">
                        <input autocomplete="off" class="form-control" [(ngModel)]="usuario.Cidade.Nome" name="cidade" formControlName="CidadeId" [placeholder]="'Cidade' | translate" />
                    </typeahead>
                </div>
            </div>


        </nb-card-body>
        <nb-card-footer>
            <div class="row" *ngIf="mensagensErro?.length > 0">
                <div class="alert alert-danger" style="width: 100%">
                    <ul>
                        <li *ngFor="let mensagem of mensagensErro">{{mensagem | translate}}</li>
                    </ul>
                </div>
            </div>
            <div class="row" *ngIf="mensagemSucesso?.length > 0" style="width: 100%">
                <div class="alert alert-success" style="width: 100%">
                    {{mensagemSucesso | translate}}
                </div>
            </div>
            <div class="row">
                <div class="col col-md-6">
                    <div *ngIf="!form.valid && !form.pristine">{{'Para salvar o registro é necessário atender todos os requisitos' | translate}}:
                        <ul>
                            <li class="" *ngFor="let erro of getFormValidationErrors()">
                                <span *ngIf="erro.keyError == 'required'">{{'O Campo'| translate}} {{display[erro.key] != null ? display[erro.key] : erro.key}} {{'é obrigatório' | translate}}</span>
                                <span *ngIf="erro.keyError == 'minlength'">{{'O Campo' | translate}} {{ display[erro.key] != null ? display[erro.key] : erro.key}} {{'não possui o mínimo de caracteres' | translate}}: {{ erro.value.actualLength }}/{{erro.value.requiredLength }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>



            <div class="row">

                <!-- <div class="col col-md-12" *ngIf="mensagensErro?.length > 0">
          <div class="alert alert-danger" style="width: 100%">
            <ul>
              <li *ngFor="let mensagem of mensagensErro">{{mensagem}}</li>
            </ul>
          </div>
        </div>

        <div class="col col-md-12" *ngIf="mensagemSucesso?.length > 0" style="width: 100%">
          <div class="alert alert-success" style="width: 100%">
            {{mensagemSucesso}}
          </div>
        </div> -->

                <div class="col col-md-2 col-xxl-1">
                    <button class="btn btn-cancelar" status="warning" type="submit">{{form.pristine ? 'Voltar' : 'Cancelar' | translate}}</button>
                </div>
                <div class="col col-md-2">
                    <button class="btn btn-success" type="submit" (click)="salvar()" [disabled]="!form.valid">{{'Salvar' | translate}}</button>
                </div>
            </div>

        </nb-card-footer>
    </nb-card>
</form>
